export class Notification {
    id: number;
    message: string;
    type: string;
    toUserId: string;
    createdDate?: any;
    modifiedDate?: any;
    viewed: boolean;
}
